<template>
  <SingleCard>
    <template #title>
      <img ref="logo" class="logo-big" src="~assets/img/login-logo.png" />
      <div class="logo-fake"></div>
    </template>
    <template #body>
      <ValidationObserver ref="form" slim>
        <VForm>
          <VLayout row>
            <TextFieldWithValidation
              v-model="email"
              rules="required|email"
              label="Enter your email"
              name="email"
              autocomplete="email"
              type="email"
              @keyup.enter="signin"
            />
          </VLayout>
          <VLayout row>
            <TextFieldWithValidation
              v-model="password"
              rules="required"
              label="Password"
              name="password"
              autocomplete="current-password"
              type="password"
              @keyup.enter="signin"
            />
          </VLayout>
          <VLayout align-center justify-center row>
            <VFlex xs12 sm6>
              <VCheckbox v-model="rememberMe" class="checkbox">
                <template v-slot:label>
                  <div class="options">Remember me</div>
                </template>
              </VCheckbox>
            </VFlex>
            <VFlex xs12 sm6>
              <NuxtLink
                class="options options--password"
                :to="{ name: 'auth-reset' }"
                >FORGOT YOUR PASSWORD?
              </NuxtLink>
            </VFlex>
          </VLayout>
        </VForm>
      </ValidationObserver>
    </template>
    <template #actions>
      <VLayout wrap justify-space-between pa-2>
        <VBtn
          :disabled="submitting"
          :loading="submitting"
          color="#4D5CD9"
          ripple
          block
          dark
          width="180"
          height="60"
          @click="signin"
        >
          Enter
        </VBtn>
      </VLayout>
      <VLayout wrap justify-space-between pa-2>
        <VBtn
          :disabled="submitting"
          :loading="submitting"
          color="#4D5CD9"
          ripple
          block
          dark
          width="180"
          height="60"
          @click="discordLogin"
        >
          Login Via Discord
        </VBtn>
      </VLayout>
    </template>
    <template #under-card>
      <nuxt-link :to="{ name: 'auth-create' }"
        >Create customer account
      </nuxt-link>
    </template>
  </SingleCard>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import SingleCard from '~/components/base/SingleCard'
import TextFieldWithValidation from '~/components/TextFieldWithValidation'
import graphql from '~/gql'

export default {
  name: 'LoginForm',
  components: {
    SingleCard,
    TextFieldWithValidation,
    ValidationObserver
  },
  data: () => ({
    email: '',
    password: '',
    rememberMe: false,
    submitting: false
  }),
  methods: {
    discordLogin() {
      window.location = 'https://api.aestell.com/auth/discord'
    },
    async signin() {
      try {
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.$nuxt.$loading.start()
          try {
            const res = await this.$apollo.mutate({
              mutation: graphql.auth.login,
              variables: {
                loginUserInput: {
                  email: this.email,
                  password: this.password
                }
              }
            })
            await this.$store.dispatch('auth/login', {
              user: res.data.login.user,
              token: res.data.login.token
            })
            await this.$store.dispatch('auth/getCurrentUser')
            this.$router.push({ name: 'dashboard' })
          } catch (e) {
            console.error(e)
          } finally {
            this.$nuxt.$loading.finish()
          }
        }
      } catch (error) {
        console.log('Validation error:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-big {
  position: absolute;
  top: 0;
}

.logo-fake {
  height: 210px;
}

.options {
  font-size: 12px;
  line-height: 12px;

  &--password {
    display: inline-block;
    margin-bottom: 12px;
  }
}
</style>
